import React from 'react';
import { Phone, Sparkles, Instagram } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section id="inicio" className="relative bg-black pt-20 pb-20 md:pb-28 overflow-hidden" data-id="element-323" data-mp="eibpbktviu8x">
      {/* Cinematic ambient glows */}
      <div className="absolute top-[20%] left-[10%] w-[40%] h-[40%] bg-gold/10 rounded-full blur-[70px] pointer-events-none" data-id="element-324" data-mp="4lyuukqi8cd4"></div>
      <div className="absolute bottom-[10%] right-[5%] w-[35%] h-[35%] bg-amber-500/5 rounded-full blur-[70px] pointer-events-none" data-id="element-325" data-mp="128fsjr35grze"></div>

      {/* Banner as cinematic backdrop — blended into the page */}
      <div className="relative w-full" data-id="element-326" data-mp="s9zybf8tt2lo">
        <motion.div initial={{
        opacity: 0,
        scale: 1.05
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: 'easeOut'
      }} className="relative w-full mx-auto" style={{
        // Soft feathered mask: fade top, bottom, and sides into the black bg
        WebkitMaskImage: 'radial-gradient(ellipse 90% 80% at 50% 45%, black 55%, transparent 100%)',
        maskImage: 'radial-gradient(ellipse 90% 80% at 50% 45%, black 55%, transparent 100%)'
      }} data-id="element-327" data-mp="sd4cn5g09eq2">
          <img src="https://cdn.magicpatterns.com/uploads/czW7Jm1q4acMh4Z8Tfj8ra/banner_celebrateyp.png" alt="Celebrate Your Party — Mirror Photo Booth con abuela y novia" className="w-full h-auto block max-h-[80vh] object-cover object-center mx-auto" fetchPriority="high" decoding="async" width={1568} height={648} data-id="element-328" data-mp="3e7l6tzl44gi4" />

          {/* Subtle film grain / cinematic warm glow on top of the banner */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-transparent to-black/80 pointer-events-none" data-id="element-329" data-mp="2hjoxnfs08ngx"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent pointer-events-none" data-id="element-330" data-mp="2lml98mj4njbd"></div>
        </motion.div>

        {/* Floating sparkles (decorative cinematic dust) */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 2,
        delay: 0.6
      }} className="absolute inset-0 pointer-events-none" data-id="element-331" data-mp="ibyr8h66ta4a">
          <Sparkles className="absolute top-[20%] left-[15%] w-4 h-4 text-gold/40 animate-pulse" data-id="element-332" data-mp="161t2iuauyqmf" />
          <Sparkles className="absolute top-[60%] right-[20%] w-5 h-5 text-gold/30 animate-pulse" style={{
          animationDelay: '1s'
        }} data-id="element-333" data-mp="112pwp7n20gde" />
          <Sparkles className="absolute top-[35%] right-[12%] w-3 h-3 text-gold/50 animate-pulse" style={{
          animationDelay: '2s'
        }} data-id="element-334" data-mp="x3h6gcr830ml" />
          <Sparkles className="absolute bottom-[15%] left-[25%] w-3 h-3 text-gold/40 animate-pulse" style={{
          animationDelay: '0.5s'
        }} data-id="element-335" data-mp="3htq0hyq6ywpm" />
        </motion.div>
      </div>

      {/* Headline + CTAs — sits cinematically beneath, blended with banner fade */}
      <div className="container mx-auto px-4 md:px-6 relative z-10 -mt-12 md:-mt-20" data-id="element-336" data-mp="2b0pptc679alq">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.5,
        ease: 'easeOut'
      }} className="max-w-4xl mx-auto text-center" data-id="element-337" data-mp="2b2kcaux4darx">
          <motion.h2 initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} className="font-script text-3xl md:text-5xl text-gold mb-4 drop-shadow-[0_0_25px_rgba(212,175,55,0.4)]" data-id="element-338" data-mp="2tyadifx8a34r">
            Recuerdos que duran toda la vida
          </motion.h2>

          <h1 className="font-serif text-2xl md:text-4xl lg:text-5xl font-bold text-cream leading-tight mb-6 drop-shadow-[0_4px_20px_rgba(0,0,0,0.9)]" data-id="element-339" data-mp="e9trttwcg33e">
            ¿Y si pudieras llevarte a casa un álbum de fotos impresas de tus
            mejores recuerdos de ese día tan especial?
          </h1>

          <p className="text-base md:text-xl text-cream/80 mb-10 max-w-2xl mx-auto font-light italic drop-shadow-[0_2px_10px_rgba(0,0,0,0.8)]" data-id="element-340" data-mp="3crz0ch426akc">
            Mirror Photo Booth de lujo para bodas, quinceañeras y graduaciones
            en Atlanta.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-341" data-mp="3mniw93imh993">
            <a href="#reservar" className="flex items-center justify-center gap-2 bg-gold hover:bg-gold-light text-ink px-8 py-4 rounded-full font-bold text-lg transition-all hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] hover:-translate-y-1" data-id="element-342" data-mp="2yxyaydyzxzwn">
              <Phone size={20} data-id="element-343" data-mp="1eayjb6nx6gt8" />
              <span data-id="element-344" data-mp="1eb6zb7fca28n">Reserva tu Fecha</span>
            </a>

            <a href="tel:+14049409785" className="flex items-center justify-center gap-2 border-2 border-gold/70 text-gold hover:bg-gold/10 backdrop-blur-sm px-8 py-4 rounded-full font-bold text-lg transition-all" data-id="element-345" data-mp="zlskvkwwoume">
              <span data-id="element-346" data-mp="1x7zrt1gomz1x">Llámanos: (404) 940-9785</span>
            </a>
          </div>

          <a href="https://instagram.com/celebrateyp" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 mt-8 text-gold hover:text-gold-light transition-all group" data-id="element-347" data-mp="1x5voakmp4226">
            <Instagram className="w-5 h-5 group-hover:drop-shadow-[0_0_10px_rgba(212,175,55,0.7)] transition-all" data-id="element-348" data-mp="7s0b8zaqi7c9" />
            <span className="font-script text-2xl" data-id="element-349" data-mp="bsslnvvceia4">@celebrateyp</span>
            <span className="text-cream/50 text-sm font-light hidden sm:inline" data-id="element-350" data-mp="2eg942p6tadag">
              · Síguenos
            </span>
          </a>
        </motion.div>
      </div>
    </section>;
}